// extracted by mini-css-extract-plugin
export default {"submit":"passwordReset_submit__mp05m","rememberedPassword":"passwordReset_rememberedPassword__nHISL","link":"passwordReset_link__rlGMY"};